import ContactFloatingButton from './ContactFloatingButton'

export default function SkillsDesign() {
  return (
    <div>
      {/* 디자인 - 심미성은 기본 ~ */}
      <div className='container w-full mx-auto bg-sk-white max-md:px-20'>
        <div className='flex items-start justify-between py-48 sm:py-64 sm:items-center max-sm:flex-col sm:flex max-sm:gap-12'>
          <div className='flex flex-col items-start gap-6'>
            <p className='text-h2-medium sm:text-h1-medium text-sk-info'>디자인</p>
            <p className='text-title3-bold lg:text-title2-bold 2xl:text-title1-bold text-sk-default'>
              심미성은 기본, 사업에 알맞는 디자인으로 <br className='hidden sm:block' />
              사용자를 생각하는 UXUI를 제공합니다
            </p>
          </div>
          <p className='text-body1-long-medium text-sk-sub'>
            시그마테크놀로지는 모든 요소를 총체적으로 생각하고 연결합니다.{' '}
            <br className='hidden sm:block' />
            사용자도 관리자도 편리한 디자인을 제공하기 위해 고민합니다
          </p>
        </div>
      </div>
      {/* 사례 */}
      <div className='container flex items-start justify-center gap-40 mx-auto max-sm:flex-col py-60 sm:py-80 bg-sk-white max-md:px-20'>
        <div className='flex flex-col items-start gap-32'>
          <img src={require('assets/images/skills-design_ex1.png')} alt='' />
          <div className='flex flex-col items-start gap-16'>
            <div className='flex flex-col items-start gap-4'>
              <p className='text-body1-medium sm:text-h2-medium text-sk-info'>고객 사례</p>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
                반응형 웹사이트
              </p>
            </div>
            <p className='text-body1-medium sm:text-h2-medium text-sk-default'>
              어떠한 기기에서도 최적화된 디자인으로
              <br />
              일관되고 연결된 사용성을 제공할 수 있습니다
            </p>
          </div>
        </div>
        <div className='flex flex-col items-start gap-32'>
          <img src={require('assets/images/skills-design_ex2.png')} alt='' />
          <div className='flex flex-col items-start gap-16'>
            <div className='flex flex-col items-start gap-4'>
              <p className='text-body1-medium sm:text-h2-medium text-sk-info'>고객 사례</p>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
                대시보드/관리자 페이지
              </p>
            </div>
            <p className='text-body1-medium sm:text-h2-medium text-sk-default'>
              서비스 운영에 필요한 데이터 시각화 및 설정, 관리 기능에{' '}
              <br className='hidden 2xs:block' />
              특화된 UXUI 디자인이 가능합니다
            </p>
          </div>
        </div>
      </div>
      {/* 지나치지 않고 편리함과 ~ */}
      <div className='py-60 sm:pt-80 skills_background2'>
        <div className='container flex items-center justify-center mx-auto max-md:px-20'>
          <div className='flex items-center gap-60 sm:gap-120 max-sm:flex-col'>
            <img src={require('assets/images/skills-design_image1.png')} alt='' />
            <div className='flex flex-col items-start gap-24'>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold test-sk-default'>
                지나치지 않고 편리함과
                <br />
                다양성을 생각합니다
              </p>
              <p className='text-body1-long-regular text-sk-info'>
                홈페이지 제작 시에는 많은 고려사항이 있습니다
                <br />주 타켓층, 브랜드 컨셉, 사이트 특성 등 셀 수 없이 많은데{' '}
                <br className='hidden 2xs:block' />
                사용 기기마저 점점 많아져서 세심하게 제작할수록 오래 사용하실 수 있어요
                <br />
                전문가가 꼼꼼히 체크하고 제작하겠습니다
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='container mx-auto max-sm:flex-col max-sm:flex max-sm:gap-60 max-md:px-20'>
        {/* 기획에 알맞은 ~ */}
        <div className='flex items-center justify-center'>
          <div className='max-sm:flex-col-reverse flex items-center sm:gap-[130px]'>
            <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
              기획에 알맞는 <br />
              디자인을 구성합니다
            </p>
            <img src={require('assets/images/skills-design_image2.png')} alt='' />
          </div>
        </div>
        {/* 직관적이게 정리하여 ~ */}
        <div className='flex items-center justify-center'>
          <div className='flex max-sm:flex-col items-center gap-60 sm:gap-[130px]'>
            <img src={require('assets/images/skills-design_image3.png')} alt='' />
            <div className='flex flex-col items-start gap-12 sm:gap-24'>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
                직관적이게 정리하여 가독성을 높이고
                <br />
                고객편의를 생각합니다
              </p>
              <p className='text-body1-long-regular text-sk-info'>
                내용은 직관적으로 정리하고 화면 크기에
                <br />
                알맞게 분활하여 제공하였습니다
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* 원하는 대로 ~ */}
      <div className='relative flex skills_background2 sm:h-[800px] justify-center mb-[-220px] sm:mb-[-260px] py-60 overflow-x-hidden overflow-y-hidden w-full'>
        <div className='container flex items-center justify-center mx-auto gap-60 sm:gap-120 max-sm:flex-col-reverse xl:absolute xl:right-0 z-[9]'>
          <div className='flex flex-col items-start gap-12 px-20 sm:gap-24 md:px-0'>
            <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
              원하는 대로 필요한 대로
              <br />
              맞춤형 디자인을 제공합니다
            </p>
            <p className='text-body1-long-regular text-sk-info'>
              한정적인 템플릿과 다르게 원하는 대로 필요한 대로 디자인을 제공하고{' '}
              <br className='hidden sm:block' />
              기능을 제작합니다 특별한 사업을 위해 특별한 서비스를 이용해 보세요
            </p>
          </div>
          <div className='flex items-center pl-20 gap-36 md:px-0'>
            <img src={require('assets/images/skills-design_image4.png')} alt='' />
            <img
              className='max-sm:hidden'
              src={require('assets/images/skills-design_image5.png')}
              alt=''
            />
            <img src={require('assets/images/skills-design_image6.png')} alt='' />
          </div>
        </div>
        <img
          className='absolute right-0 justify-center hidden md:flex z-[11]'
          src={require('assets/images/skills-planning_gradient.png')}
          alt=''
        />
      </div>
      <ContactFloatingButton />
    </div>
  )
}
